import React from "react"
import gsap from "gsap"
import PropTypes from "prop-types"
import { useEffect } from "react"
import bgTexture from "../../assets/img/common/bg_texture.png"
import { Container, Section } from "../../components/ak-grid/grid"

const Menu = ({
  loaderImg,
  loaderAlt,
  headerImg,
  headerAlt,
  headerOutlet,
  slug,
  branch,
}) => {
  /** static data */
  const list = [
    {
      slug: "roma",
      branch: "SCBD",
      instagramUrl: "http://instagram.com/romaosteriabar",
      instagramUsername: "@romaosteriabar",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/roma",
      reviewUrl:
        "https://www.google.com/maps/place/Roma+Osteria+%26+Bar/@-6.226464,106.8064811,16z/data=!4m6!3m5!1s0x2e69f1daa55d3d2b:0x20804044e798dab3!8m2!3d-6.2252931!4d106.8074596!16s%2Fg%2F11c1qmrj_1?entry=ttu",
    },
    {
      slug: "roma",
      branch: "Pondok Indah Mall",
      instagramUrl: "http://instagram.com/romaosteriabar",
      instagramUsername: "@romaosteriabar",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/roma",
      reviewUrl:
        "https://www.google.com/maps/place/Roma+Osteria+%26+Bar+PIM+3/@-6.2634414,106.7823448,15z/data=!4m2!3m1!1s0x0:0xa0f75c4b40276edf?sa=X&ved=2ahUKEwjN9vbFhviDAxW9SGcHHRKaCyYQ_BJ6BAgOEAA",
    },
    {
      slug: "union",
      branch: "Plaza Senayan",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/Union+Brasserie,+Bakery+%26+Bar/@-6.2259469,106.7990493,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f14920b7d1cf:0xbf8f02390870ee8e!8m2!3d-6.2259469!4d106.7990493!16s%2Fg%2F1tqq0k21?entry=ttu",
    },
    {
      slug: "union",
      branch: "Grand Indonesia",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/Union+DELI/@-6.1963305,106.8219145,15z/data=!4m6!3m5!1s0x2e69f421dc202321:0x4e51f3526d4fc8e9!8m2!3d-6.1963305!4d106.8219145!16s%2Fg%2F11bw3dljby?entry=ttu",
    },
    {
      slug: "union",
      branch: "Central Park",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Central+Park/@-6.1777931,106.7900919,15z/data=!4m6!3m5!1s0x2e69f70652cc0797:0x7ccf2980caf167fa!8m2!3d-6.1777931!4d106.7900919!16s%2Fg%2F11lqkmgxxq?entry=ttu",
    },
    {
      slug: "union",
      branch: "Pondok Indah Mall",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Pondok+Indah+Mall/@-6.2678672,106.7840452,17z/data=!3m2!4b1!5s0x2e69f1a50b6304fd:0x7521cf7fac302a2!4m6!3m5!1s0x2e69f1a512932e41:0xe80ad7b2b757cf7!8m2!3d-6.2678672!4d106.7840452!16s%2Fg%2F1yfdpbq8g?entry=ttu",
    },
    {
      slug: "union",
      branch: "Senayan City",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Cafe+Senayan+City/@-6.2273089,106.7971736,17z/data=!3m2!4b1!5s0x2e69f148610ee4a3:0xaa9043c3e09853ad!4m6!3m5!1s0x2e69f18d78d4dc65:0xbd29771225f59af3!8m2!3d-6.2273089!4d106.7971736!16s%2Fg%2F11g0l5z69z?entry=ttu",
    },
    {
      slug: "union",
      branch: "Pantai Indah Kapuk",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/Union+PIK+Avenue/@-6.1095875,106.7377999,17z/data=!4m5!3m4!1s0x2e6a1d3b6df70733:0x6c032da47441c922!8m2!3d-6.1095928!4d106.739994?shorturl=1",
    },
    {
      slug: "union",
      branch: "Mall Kelapa Gading",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Mall+Kelapa+Gading+3/@-6.1560144,106.908828,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f5000c5649fb:0xd7583153e9a05b9d!8m2!3d-6.1560144!4d106.908828!16s%2Fg%2F11fd75tz3c?entry=ttu",
    },
    {
      slug: "union",
      branch: "Pakuwon Mall",
      instagramUrl: "http://instagram.com/union.sby",
      instagramUsername: "@union.sby",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Pakuwon+Mall/@-7.2882921,112.6763211,15z/data=!4m2!3m1!1s0x0:0xb771b9e46c2693ae?sa=X&ved=2ahUKEwj86ueUgviDAxWGS2wGHWuDDHQQ_BJ6BAgPEAA",
    },
    {
      slug: "union",
      branch: "Summarecon Mall Serpong",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Summarecon+Mall+Serpong/@-6.2421492,106.6285492,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69fd8c4d9644a1:0xe64bead7dd80c4b9!8m2!3d-6.2421492!4d106.6285492!16s%2Fg%2F11v5s207jk?entry=ttu",
    },
    {
      slug: "union",
      branch: "Tunjungan Plaza",
      instagramUrl: "http://instagram.com/union.sby",
      instagramUsername: "@union.sby",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://www.google.com/maps/place/UNION+Tunjungan+Plaza/@-7.2614155,112.7368278,17z/data=!3m1!4b1!4m6!3m5!1s0x2dd7f9d9523b3b89:0x8c9f4c80114ff1e9!8m2!3d-7.2614155!4d112.7394027!16s%2Fg%2F11ybnk4gl_?entry=ttu&g_ep=EgoyMDI1MDIyNi4xIKXMDSoASAFQAw%3D%3D",
    },
    {
      slug: "bistecca",
      branch: "SCBD",
      instagramUrl: "http://instagram.com/bisteccajkt",
      instagramUsername: "@bisteccajkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/bistecca",
      reviewUrl:
        "https://www.google.com/maps/place/BISTECCA/@-6.2300566,106.8100401,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f15a6a07f64f:0x8ea75ae17a022a68!8m2!3d-6.2300566!4d106.8100401!16s%2Fg%2F11cp7w1530?entry=ttu",
    },
    {
      slug: "bistecca",
      branch: "PIK Avenue",
      instagramUrl: "http://instagram.com/bisteccajkt",
      instagramUsername: "@bisteccajkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/bistecca",
      reviewUrl:
        "https://www.google.com/maps/place/BISTECCA+PIK+Avenue/@-6.1092121,106.7402097,15z/data=!4m6!3m5!1s0x2e6a1d31341fd60f:0x4e7c650c332c44ba!8m2!3d-6.1092121!4d106.7402097!16s%2Fg%2F11rj3v257k?entry=ttu",
    },
    {
      slug: "caffemilano",
      branch: "Grand Indonesia",
      instagramUrl: "http://instagram.com/caffemilanojkt",
      instagramUsername: "@caffemilanojkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/caffe-millano",
      reviewUrl:
        "https://www.google.com/maps/place/Caffe+Milano/@-6.1958957,106.8215147,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f421c06051f5:0xcbe002881285c56e!8m2!3d-6.1958957!4d106.8215147!16s%2Fg%2F11b7vlk9v1?entry=ttu",
    },
    {
      slug: "caffemilano",
      branch: "PIK Avenue",
      instagramUrl: "http://instagram.com/caffemilanojkt",
      instagramUsername: "@caffemilanojkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/caffe-millano",
      reviewUrl:
        "https://www.google.com/maps/place/CAFFÈ+MILANO+PIK+Avenue/@-6.1093401,106.7401239,15z/data=!4m6!3m5!1s0x2e6a1d9ad3170d71:0xc0d6fd5251b9e578!8m2!3d-6.1093401!4d106.7401239!16s%2Fg%2F11pd0q3sz6?entry=ttu ",
    },
    {
      slug: "corknscrewcc",
      branch: "",
      instagramUrl: "http://instagram.com/corknscrew",
      instagramUsername: "@corknscrew",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/corknscrew-cc",
      reviewUrl:
        "https://www.google.com/maps/place/CORK+%26+SCREW+COUNTRY+CLUB/@-6.2260415,106.7891201,15z/data=!3m1!4b1!4m5!3m4!1s0x2e69f1652c6621d9:0xe7dd9323532b57e8!8m2!3d-6.2260416!4d106.7978749?shorturl=1",
    },
    {
      slug: "corknscrew",
      branch: "Plaza Indonesia",
      instagramUrl: "http://instagram.com/corknscrew",
      instagramUsername: "@corknscrew",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/corknscrew",
      reviewUrl:
        "https://www.google.com/maps/place/CORK%26SCREW+Plaza+Indonesia/@-6.1941613,106.8197788,17z/data=!3m2!4b1!5s0x2e69f4211614e4ed:0x7aefc330deff9bc0!4m6!3m5!1s0x2e69f4213cd8d939:0x9c403282687928fe!8m2!3d-6.1941666!4d106.8223591!16s%2Fg%2F11r9cc3nx!5m1!1e4?entry=ttu&g_ep=EgoyMDI0MDgyOC4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      slug: "corknscrew",
      branch: "Pacific Place",
      instagramUrl: "http://instagram.com/corknscrew",
      instagramUsername: "@corknscrew",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/corknscrew",
      reviewUrl:
        "https://www.google.com/maps/place/CORK%26SCREW+Pacific+Place/@-6.2252912,106.8094621,17z/data=!3m2!4b1!5s0x2e69f1511039adeb:0xdd517b6a018180a5!4m6!3m5!1s0x2e69f40f57bbdcf1:0x74f3a56fa46f91a0!8m2!3d-6.2252912!4d106.8094621!16s%2Fg%2F1tf54_78?entry=ttu",
    },
    {
      slug: "loewy",
      branch: "",
      instagramUrl: "http://instagram.com/loewyjakarta",
      instagramUsername: "@loewyjakarta",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/loewy",
      reviewUrl:
        "https://www.google.com/maps/place/Loewy/@-6.2277244,106.8166137,15z/data=!3m1!4b1!4m5!3m4!1s0x2e69f3e4cdd2e835:0x7deaacf54b87fe0!8m2!3d-6.2277245!4d106.8253685?shorturl=1",
    },
    {
      slug: "pierre",
      branch: "",
      instagramUrl: "http://instagram.com/pierre.jkt",
      instagramUsername: "@pierre.jkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/pierre",
      reviewUrl:
        "https://www.google.com/maps/place/PIERRE/@-6.2455005,106.811507,13.55z/data=!4m5!3m4!1s0x0:0xc48babd363674d1e!8m2!3d-6.2308776!4d106.8089426?shorturl=1",
    },
    {
      slug: "the-cocktail-club",
      branch: "",
      instagramUrl: "http://instagram.com/thecocktailclubjakarta",
      instagramUsername: "@thecocktailclubjakarta",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/the-cocktail-club",
      reviewUrl:
        "https://www.google.com/maps/place/The+Cocktail+Club/@-6.2310073,106.8091491,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f1291d1ce5bf:0x8e0bb551e43831cc!8m2!3d-6.2310073!4d106.8091491!16s%2Fg%2F11p672bt3p?entry=ttu",
    },
    {
      slug: "bar-luca",
      branch: "",
      instagramUrl: "https://www.instagram.com/barlucajkt",
      instagramUsername: "@barlucajkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/barluca",
      reviewUrl:
        "https://www.google.com/maps/place/BAR+LUCA/@-6.2300409,106.8074353,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f16211a705a7:0x6979581440ceacfb!8m2!3d-6.2300409!4d106.8100102!16s%2Fg%2F11vcm2554f?hl=en&entry=ttu",
    },
    {
      slug: "bouchon",
      branch: "",
      instagramUrl: "https://www.instagram.com/bouchonjkt/",
      instagramUsername: "@bouchonjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/bouchon",
      reviewUrl:
        "https://www.google.com/maps/place/Bouchon+Jakarta/@-6.2328748,106.8121339,15z/data=!4m6!3m5!1s0x2e69f1dd75422e37:0xa30f2754ef79d01a!8m2!3d-6.2328748!4d106.8121339!16s%2Fg%2F11vq9mtrbc?entry=ttu",
    },
    {
      slug: "modernhaus",
      branch: "",
      instagramUrl: "https://www.instagram.com/modernhausjkt/",
      instagramUsername: "@modernhausjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/modernhaus",
      reviewUrl:
        "https://www.google.com/maps/place/Modernhaus/@-6.2328748,106.8121339,17z/data=!3m1!4b1!4m6!3m5!1s0x2e69f109b64a3acf:0x449c080fd7b9eebf!8m2!3d-6.2328748!4d106.8121339!16s%2Fg%2F11w3p177b7?entry=ttu&g_ep=EgoyMDI1MDIyNi4xIKXMDSoASAFQAw%3D%3D",
    },
    {
      slug: "union",
      branch: "Puri Indah Mall 2",
      instagramUrl: "http://instagram.com/unionjkt",
      instagramUsername: "@unionjkt",
      webUrl: "https://new.uniongroupjakarta.com/restaurant/union",
      reviewUrl:
        "https://search.google.com/local/writereview?placeid=ChIJdzzeUwD3aS4Roqwk5Tr54tE",
    },
  ]
  /** static data */

  /** state --- start */
  /** state --- end */

  /** function --- start */
  /** function --- end */
  /** react operation --- start */
  /** react operation --- end */

  // Animation
  useEffect(() => {
    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
    // prettier-ignore
    gsap.defaults({ ease: "expo.inOut", duration: 1 })
    // prettier-ignore
    gsap
      .timeline()
      .to(".loader .brand", 0, { css: { visibility: "visible" } })
      .from(".loader .brand", { autoAlpha: 0, delay: 1, ease: "none", })
      .to(".loader .brand", { autoAlpha: 0, }).to(".loader", { height: 0, })
      .from(".header-logo-wrapper img", 0.5, { autoAlpha: 0, y: 30, delay: -0.2, ease: "power3.out", })
      .from(".header-text-wrapper p", 0.5, { autoAlpha: 0, y: 30, delay: -0.4, ease: "power3.out", })
      .from(".btn-wrapper .btn", 1, { autoAlpha: 0, y: 45, delay: -0.6, ease: "power3.out", stagger: { amount: 0.3, }, })
      .from(".social-link-wrapper .social-link", 1, { autoAlpha: 0, y: 45, delay: -0.6, ease: "power3.out", stagger: { amount: 0.3, }, })
      .from("footer p", 0.75, { autoAlpha: 0, y: 20, delay: -0.5, ease: "power3.out", })
      .from("footer .el-before", 0.75, { autoAlpha: 0, y: 20, delay: -0.5, ease: "power3.out", })
  }, [])

  /** react operation */
  const data = list.find(
    item =>
      item.slug === slug && (branch.length ? item.branch === branch : true)
  )
  return (
    <div className="wrapper">
      <div className="loader">
        <img src={loaderImg} className="brand img-fluid" alt={loaderAlt} />
      </div>
      <img src={bgTexture} className="d-none" />

      <div className="menu-landing-wrapper">
        <Section className="menu-landing-header">
          <Container className="mw-md">
            <div className="overflow-hidden header-logo-wrapper mb-0">
              <img src={headerImg} alt={headerAlt} className="img-fluid" />
            </div>
            {headerOutlet !== "" && (
              <div className="overflow-hidden header-text-wrapper">
                <p>{headerOutlet}</p>
              </div>
            )}
          </Container>
        </Section>

        <Section className="menu-landing-body pt-0">
          <Container className="mw-md">
            <div className="overflow-hidden btn-wrapper">
              <a
                rel="noopener noreferrer"
                href="https://onelink.to/nre88n"
                target="_blank"
                className="btn btn-primary"
              >
                {slug === "roma" ? "U+Rewards" : "U+REWARDS"}
                <div className="el-after" />
              </a>
            </div>
            <div className="overflow-hidden btn-wrapper">
              <a
                href={data.reviewUrl}
                className={`btn btn-payment`}
                rel="noopener noreferrer"
                target="_blank"
              >
                Leave a Review
              </a>
            </div>
            <div className="overflow-hidden social-link-wrapper">
              <div className="social-link">
                <a
                  href={data.instagramUrl}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="btn-link"
                >
                  {data.instagramUsername}
                </a>
                <a
                  href={data.webUrl}
                  target="_blank"
                  className="btn-link"
                  rel="noopener noreferrer"
                >
                  wwww.uniongroupjakarta.com
                </a>{" "}
              </div>
            </div>
          </Container>
        </Section>
      </div>

      <footer>
        <span className="el-before" />
        <Container>
          <div className="overflow-hidden footer-text-wrapper">
            <p>{new Date().getFullYear()} The Union Group</p>
          </div>
        </Container>
      </footer>
    </div>
  )
}

Menu.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
}

Menu.defaultProps = {
  className: "",
  slug: "",
  branch: "",
}

export default Menu
